import { gql } from '@apollo/client'

export const DASHBOARD_CREATE_MUTATION = gql`
  mutation DASHBOARD_CREATE_MUTATION($input: DashboardCreateInput!) {
    dashboardCreate(input: $input) {
      id
    }
  }
`

export const DASHBOARD_DELETE_MUTATION = gql`
  mutation DASHBOARD_DELETE_MUTATION($input: DashboardDeleteInput!) {
    dashboardDelete(input: $input) {
      ok
    }
  }
`

export const DASHBOARD_UPDATE_MUTATION = gql`
  mutation DASHBOARD_UPDATE_MUTATION($input: DashboardUpdateInput!) {
    dashboardUpdate(input: $input) {
      id
    }
  }
`

export const DASHBOARD_ITEM_CREATE_MUTATION = gql`
  mutation DASHBOARD_ITEM_CREATE_MUTATION($input: DashboardItemCreateInput!) {
    dashboardItemCreate(input: $input) {
      id
    }
  }
`

export const DASHBOARD_ITEM_DELETE_MUTATION = gql`
  mutation DASHBOARD_ITEM_DELETE_MUTATION($input: DashboardItemDeleteInput!) {
    dashboardItemDelete(input: $input) {
      ok
    }
  }
`

export const DASHBOARD_ITEM_UPDATE_MUTATION = gql`
  mutation DASHBOARD_ITEM_UPDATE_MUTATION($input: DashboardItemUpdateInput!) {
    dashboardItemUpdate(input: $input) {
      id
    }
  }
`
